import { render, staticRenderFns } from "./smsStats.vue?vue&type=template&id=8db106a0&scoped=true&"
import script from "./smsStats.vue?vue&type=script&lang=ts&"
export * from "./smsStats.vue?vue&type=script&lang=ts&"
import style0 from "./smsStats.vue?vue&type=style&index=0&id=8db106a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db106a0",
  null
  
)

export default component.exports